import { Router } from "router";
import { ThemeProvider } from "styled-components";
import { GlobalStyle } from "styles/global";
import { lightTheme } from "styles/themes/light";
import { ThemeProvider as MUIThemeProvider } from "@material-ui/core";
import { muiTheme } from "styles/themes/MUITheme";

function App() {
  return (
    <MUIThemeProvider theme={muiTheme}>
      <ThemeProvider theme={lightTheme}>
        <GlobalStyle />
        <Router />
      </ThemeProvider>
    </MUIThemeProvider>
  );
}

export default App;
